<template>
    <div class="form-field" :rel="name" v-bind:class="{'has-suffix': suffix}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <input type="password" value="" v-model="internalValue"/>
                <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormPassword',
        props: ['value','label','suffix','name'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Password.vue